function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
import * as actions from '../actions/eotcActions';
import { distinct } from '../../helpers/arrayHelper';
var initialState = {
  priceUpdates: {},
  lastPrices: {}
};
var formatPrice = function formatPrice(priceUpdate) {
  return {
    Time: priceUpdate[0],
    Bid: priceUpdate[2],
    Ask: priceUpdate[3],
    Mid: priceUpdate[4]
  };
};
var isPriceNewer = function isPriceNewer(lastPrice, newPrice) {
  if (!lastPrice) return true;
  if (lastPrice.Time < newPrice[0]) return true;
  return false;
};
export default function eotcPriceReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case actions.ADD_PRICE:
      var InstrumentId = payload[1];
      var stateUpdate = Object.assign({}, state, {
        priceUpdates: _defineProperty({}, InstrumentId, distinct([formatPrice(payload)].concat(_toConsumableArray(state.priceUpdates[InstrumentId] || [])),
        /**
         * Treat timestamp as unique ID.
         */
        function (price) {
          return price.Time;
        }))
      });
      if (isPriceNewer(state.lastPrices[InstrumentId], payload)) {
        /**
         * Save as last price in state.
         */
        stateUpdate.lastPrices[InstrumentId] = formatPrice(payload);
      }
      return stateUpdate;
    default:
      return state;
  }
}